import { createSelector } from 'reselect';
import { fetchCityStateSuggestion } from '@/redux/api/cityStateSuggestion';
import { getAuthToken } from './user';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';

const LOAD_CITY_STATE_FAIL = 'la/ui/loadcitystate/FAIL';
export const LOAD_CITY_STATE_REQUEST = 'la/ui/loadcitystate/REQUEST';
export const LOAD_CITY_STATE_SUCCESS = 'la/ui/loadcitystate/SUCCESS';

const DEFAULT_STATE = {
    data: { city: '', state: '', zip: '' },
    submitted: false,
    success: false,
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOAD_CITY_STATE_FAIL:
            return {
                ...state,
                submitted: false,
                success: false,
            };
        case LOAD_CITY_STATE_REQUEST:
            return {
                ...state,
                submitted: true,
                success: false,
            };
        case LOAD_CITY_STATE_SUCCESS:
            return {
                ...state,
                data: { city: action.payload[0].city, state: action.payload[0].state },
                submitted: false,
                success: true,
            };
        default:
            return state;
    }
}

const stateSelector = (state: GlobalState) => state.cityStateSuggestion;

export const getCityStateSuggestion = createSelector(stateSelector, (state) => state);

export const loadCityAndStateByZip = (zipcode: string) => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        dispatch({
            type: LOAD_CITY_STATE_REQUEST,
        });
        const response = await fetchCityStateSuggestion({ authToken, deployment, zipcode });

        dispatch({
            payload: response.data,
            type: LOAD_CITY_STATE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: LOAD_CITY_STATE_FAIL,
        });
    }
};
